module.exports = __webpack_public_path__ + "img/replace-battery-crossed.ea8642ca.svg";